export default __webpack_public_path__ + "static/media/ab01.d5ba2214.jpg";